import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FormattedMessage, useIntl } from 'react-intl';
import { onIsSidebarVisible } from '../../store/helpers/helpersSlice';
import { Tooltip } from '@chakra-ui/react';
import { ReactComponent as CollapseFullscreenIcon } from '../../icons/collapse-fullscreen.svg';
import { ReactComponent as ExpandFullscreenIcon } from '../../icons/expand-fullscreen.svg';

import SecondaryIconButton from '../utils/SecondaryIconButton';

const ShowHideSidebarButton = ({ includeMessage = true }) => {
    const { isSidebarVisible } = useSelector((state) => state.helpers);
    const dispatch = useDispatch();
    const intl = useIntl();

    useEffect(() => {
        return () => {
            dispatch(onIsSidebarVisible(true));
        };
    }, [dispatch]);

    const changeExpanded = () => {
        dispatch(onIsSidebarVisible(!isSidebarVisible));
    };

    return (
        <Tooltip
            label={intl.formatMessage({
                id: !isSidebarVisible ? 'common_collapse_btn_tooltip' : 'common_expand_btn_tooltip',
            })}
        >
            <SecondaryIconButton
                leftIcon={!isSidebarVisible ? <CollapseFullscreenIcon /> : <ExpandFullscreenIcon />}
                size="sm"
                type="button"
                variant="secondary"
                onClick={changeExpanded}
            >
                {includeMessage && (
                    <FormattedMessage id={!isSidebarVisible ? 'common_collapse_btn' : 'common_expand_btn'} />
                )}
            </SecondaryIconButton>
        </Tooltip>
    );
};

export default ShowHideSidebarButton;
